export default __webpack_public_path__ + "scene1_1_icon259a3a.png";